import { Component, ElementRef, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ApiServiceService } from 'src/app/api-service.service';
import { DatePipe, formatDate } from '@angular/common'
import { Router } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/api';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { AppUtility } from 'src/app/interceptor/appUtitlity';
@Component({
  selector: 'app-generated-asn-list',
  templateUrl: './generated-asn-list.component.html',
  styleUrls: ['./generated-asn-list.component.scss'],
  providers: [DatePipe],
})

export class GeneratedAsnListComponent {
  breadcrumb = [
    {
      title: 'Generated ASN List',
      subTitle: 'Dashboard'
    }
  ]
  selectedJde: any = {}; // To store selected object
  supplierList: any = [];
  excelData: any[] = [];
  filteredXLSData: any[] = [];
  orderCo: any
  jdedata: any[] = [];
  jdedatabyid: any[] = []
  orderLineStatus: any;
  filterval: string
  filteredJdeData: any[];
  entyDate: any;
  orderNumber: any;
  status: string;
  mrastatus: string;
  mraremark: string;
  dateUpdated: any;
  foreignUnitCost: any;
  exchangeRate: any;
  currency: any;
  glOffset: any;
  buyerNumber: any;
  invoiceNumber: any;
  paymentTerm: any;
  extendedPrice: any;
  unitPrice: any;
  quantityOpen: any;
  quantityOrdered: any;
  unitOfMeasure: any;
  valueStream2: any;
  valueStream1: any;
  valueStreamDesc: any;
  valueStream: any;
  lastStatusDesc: any;
  lastStatus: any;
  nextStatusDesc: any;
  nextStatus: any;
  lineType: any;
  description2: any;
  description1: any;
  foreignExtendedPrice: any;
  orderSuffix: any;
  lineNumber: any;
  businessUnit: any;
  asnumber: any;
  billToName: any;
  shipToNumber: any;
  shipToName: any;
  invoicedate: any;
  requestedDate: any;
  scheduledPickDate: any;
  cancelDate: any;
  shortItemNumber: any;
  itemNumber: any;
  userroleName: any;
  shipqty: any
  display: boolean = false
  displaycredit: boolean = false
  pendingCreditNoteFile: File | null = null;
  isToggleActive: boolean = false;
  selectedPayloadStatus: string | null = null;
  selectedJdeList: any = [] = []
  msgs: Message[] = [];
  ApprovedRemark = new FormControl('', Validators.required);
  originalSelectedJdeList: any;
  valueStreamdropdown: any;
  tdsdropdown: any;
  username: string;
  userid: number;
  orderno: string;
  grnstatus: any[] = [
    { id: 1, value: 'credit note' },
    { id: 2, value: 'Partial Receipt' },
    { id: 3, value: 'Fully Receipt' },
  ]

  payloadStatuses: any[] = [];

  @ViewChild('fileInput') fileInput: ElementRef;
  constructor(private _apiService: ApiServiceService, private confirmationService: ConfirmationService, public _utility: AppUtility, private datePipe: DatePipe,
    private router: Router, private fb: FormBuilder
  ) { }
  toolLoanForm = this.fb.group({
    uploadDoc: new FormControl(null, [Validators.required]),
  });
  @ViewChild('dt2') dataTable: Table;
  ngOnInit(): void {
    this.userroleName = this._utility.getLocalStorageDetails();
    this.username = this.userroleName.userName;
    this.userid = this.userroleName.loginId;
    this.initializeDropdown();
    this.getdata();
    this.getAllTableData();
    this.getAllTdsData();
  }

  initializeDropdown() {
    const role = this.userroleName.roleName;

    // Based on the table binding (asnStatus vs checkerStatus buttons)
    const asnStatuses = [
      { label: 'ASN Generated', value: 'ASNGenerated' },
      { label: 'Pending', value: 'Pending' },
      { label: 'Rework', value: 'Rework' },
      { label: 'Material Inward', value: 'Material Inward' },
      { label: 'Partial Receipt', value: 'Partial GRN' },
      { label: 'Fully Receipt', value: 'Fully Receipt' },
      { label: 'Approved for MRA', value: 'Approved for MRA' },
      { label: 'Partial Inward', value: 'Partial Inward' },
      { label: 'Deleted', value: 'Deleted' }
    ];

    const checkerStatuses = [
      { label: 'Pending', value: 'Pending' },
      { label: 'Rework', value: 'Rework' },
      { label: 'Partial Receipt', value: 'Partial GRN' },
      { label: 'Fully Receipt', value: 'Fully Receipt' },
      { label: 'Approved for MRA', value: 'Approved for MRA' },
      { label: 'AT PV Approval', value: 'AT PV Approval' },
      { label: 'Partial Inward', value: 'Partial Inward' },
      { label: 'Deleted', value: 'Deleted' }
    ];

    if (role === 'Admin') {
      // Merge unique values
      const merged = [...asnStatuses, ...checkerStatuses];
      this.payloadStatuses = merged.filter((v, i, a) => a.findIndex(t => t.value === v.value) === i);
    } else if (role === 'Supplier') {
      // Supplier binds and sees asnStatus
      this.payloadStatuses = [...asnStatuses];
    } else {
      // Store, Finance and other roles usually bind to checkerStatus logic
      this.payloadStatuses = [...checkerStatuses];
    }
  }


  toggleData() {
    this.isToggleActive = !this.isToggleActive;
    this.getdata();
  }

  getdata() {
    this._utility.loader(true);
    const payload = {
      "status": this.selectedPayloadStatus
    }
    const apiCall = this._apiService.getasn(payload);
    apiCall
      .then((res: any) => {
        console.log(res);
        if (res.success) {
          this.jdedata = res.data;
          console.log(this.jdedata);
          this.jdedata.forEach(jde => {
            if (jde.isDeleted) {
              jde.asnStatus = 'Deleted';
              jde.checkerStatus = 'Deleted';
            }
            if (!jde.isApproved) {
              jde.selected = true;

            }

            jde.formattedInvoiceDate = jde.invoiceDate
              ? formatDate(jde.invoiceDate, 'dd/MM/yy', 'en-US')
              : '';


          });

        } else {
          this.jdedata = [];
        }
      })
      .catch((error) => {
        this._apiService.showMessage(error.message, "error");
        this.jdedata = [];
      })
      .finally(() => {
        this._utility.loader(false);
      });
  }



  isExchangeRateValid(exchangeRate: any): string | number {
    // Check if exchangeRate is a valid number, return it if true, otherwise return '-'
    return typeof exchangeRate === 'number' ? exchangeRate : '- ';
  }

  reset() {
    this.filterval = ''
    this.orderCo = ''
    this.orderNumber = ''
    this.status = ''
    this.dateUpdated = ''
    this.foreignUnitCost = ''
    this.exchangeRate = ''
    this.currency = ''
    this.glOffset = ''
    this.buyerNumber = ''
    this.invoiceNumber = ''
    this.paymentTerm = ''
    this.extendedPrice = ''
    this.unitPrice = ''
    this.quantityOpen = ''
    this.quantityOrdered = ''
    this.unitOfMeasure = ''
    this.valueStream2 = ''
    this.valueStream1 = ''
    this.valueStreamDesc = ''
    this.valueStream = ''
    this.lastStatusDesc = ''
    this.lastStatus = ''
    this.nextStatusDesc = ''
    this.nextStatus = ''
    this.lineType = ''
    this.description2 = ''
    this.description1 = ''
    this.foreignExtendedPrice = ''
    this.orderSuffix = ''
    this.lineNumber = ''
    this.businessUnit = ''
    this.asnumber = ''
    this.billToName = ''
    this.shipToNumber = ''
    this.shipToName = ''
    this.invoicedate = ''
    this.requestedDate = ''
    this.scheduledPickDate = ''
    this.cancelDate = ''
    this.shortItemNumber = ''
    this.itemNumber = ''
    this.shipqty = ''
    this.orderLineStatus = ''
    this.mraremark = ''
    this.mrastatus = ''
    this.orderno = ''
    this.dataTable.reset();
    location.reload();


  }
  onXLSExport() {
    let filteredBy

    for (let i = 0; i < this.jdedata.length; i++) {

      this.excelData.push({
        'S.No.': i + 1,
        'ASN Number': this.jdedata[i]?.asnNumber ?? '-',
        'Order Number': this.jdedata[i]?.orderNumber ?? '-',
        'Ship Qty': this.jdedata[i]?.ship ?? '-',
        'Total Amount': this.jdedata[i]?.value ?? '-',
        'Invoice': this.jdedata[i]?.invoicePath ?? '-',
        'Delivery Challan': this.jdedata[i]?.deliveryChaalanPath ?? '-',
        'Eway Bill': this.jdedata[i]?.ewayBillPath ?? '-',
      });


    }
    this._apiService.exportExcel(this.excelData, 'ASN-list', filteredBy);
  }
  sendSelectedData() {
    const selectedData = this.jdedata.filter(item => item.selected);
    console.log(selectedData);

    if (selectedData.length > 0) {
      // Navigate to the new page and pass selected data
      this._apiService.setSelectedData(selectedData);
      this.router.navigate(['/asn-generation']);
    } else {
      this._apiService.showMessage('please select atleast one checkbox', 'error');

    }
  }
  selectedASN: any;
  openModal(selectedRow: any) {
    this._utility.loader(true);
    console.log(selectedRow, "cekced daayy");
    const data = {
      asnnumber: selectedRow.asnNumber
    }
    this._apiService.getgenerateddata(data)
      .then((res: any) => {
        console.log("API Response:", res);

        if (res.success) {
          this.jdedatabyid = res.data;
        } else {
          this.jdedatabyid = [];
        }

        // Use the selected row directly
        if (selectedRow) {
          this.selectedASN = selectedRow;
          const asnNumber = this.selectedASN.asnNumber;

          // Filter by ASN number
          this.selectedJdeList = this.jdedatabyid.filter(asn => asn.asnNumber === asnNumber);
          console.log(this.selectedJdeList, "called");

          this.selectedJdeList.forEach(jde => {
            if (!jde.isApproved) {
              jde.selected = true;
            }
            // Normalize invoiceDate to "YYYY-MM-DD" so <input type="date"> binds correctly
            if (jde.invoiceDate) {
              jde.invoiceDate = jde.invoiceDate.split('T')[0];
            }
            // Snapshot original GRN status so disabled state doesn't change when dropdown is edited
            jde._originalGrnPendingStatus = jde.grnPendingStatus;
          });

          this.originalSelectedJdeList = JSON.parse(JSON.stringify(this.selectedJdeList));

          // Add missing valueStream2 values to dropdown
          this.selectedJdeList.forEach(jde => {
            if (
              jde.valueStream2 &&
              !this.valueStreamdropdown.some(v => v.valueStreamName === jde.valueStream2)
            ) {
              this.valueStreamdropdown.push({ valueStreamName: jde.valueStream2 });
            }
          });
          console.log(this.selectedJdeList, "cALLED");

          this.display = true; // Show modal
          console.log(typeof this.selectedJdeList[0].invoiceDate, "cheked");
        } else {
          console.error("No row data passed.");
          this._apiService.showMessage("Data not found!", "error");
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        this._apiService.showMessage(error.message, "error");
        this.jdedatabyid = [];
      })
      .finally(() => {
        this._utility.loader(false);
      });
  }



  getDocumentPaths(request: any): { label: string, path: string }[] {
    const possiblePaths = [
      "qualityCertificatePath",
      "insuranceClassificationPath",
      "logisticDocumentPath",
      "certificatePath",
      "orderAcknowledgementPath",
      "proformaInvoicePath",
      "packingListPath",
      "deliveryDocumentPath",
      "certificateofOriginPath",
      "thirdPartyInsCerTPIPath",
      "warrantyCertificatePath",
      "freightClassificationPath",
      "abgpbgPath"
    ];

    let documents: { label: string, path: string }[] = [];

    for (let path of possiblePaths) {
      if (request[path]) {
        documents.push({ label: request.itemsJson, path: request[path] });
      }
    }


    return documents; // Return all valid document paths
  }
  confirmDelete(number) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Delete ASN Record',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteasn(number);
      },
      reject: () => {
        this._apiService.showMessage('Canceled', 'info')
      }
    });

  }
  deleteasn(number: Number) {
    console.log(number);
    this._utility.loader(true);
    this._apiService.deleteASN(number).then((res: any) => {
      this._utility.loader(false);
      if (res.success) {
        this._apiService.showMessage(res.message, 'success');
        this.getdata();
      }
      else {
        this._apiService.showMessage(res.message, 'error');
      }
    }).catch(err => {
      this._utility.loader(false);
      this._apiService.showMessage(err?.message || 'Error deleting ASN', 'error');
    });
  }

  lastApprovedData: any = null;
  btnClick(action: string) {
    if (!this.ApprovedRemark.value || this.ApprovedRemark.value.trim() === '') {
      this._apiService.showMessage('Remark/Reason is required', 'error');
      this.ApprovedRemark.markAsTouched();
      return;
    }
    if (action === 'approve') {
      const isPVApproval = this.selectedJdeList[0]?.checkerStatus == 'AT PV Approval';
      const listToValidate = isPVApproval
        ? this.selectedJdeList
        : this.selectedJdeList.filter(jde => jde.selected);

      if (listToValidate.length === 0) {
        this._apiService.showMessage('Please select at least one row to approve', 'error');
        return;
      }

      const invalidRows = listToValidate.filter(jde => {
        const qty = Number(jde.grnPendingQty);
        return qty !== 0 && !jde.grnPendingStatus;
      });

      if (invalidRows.length > 0) {
        this._apiService.showMessage(
          'Please select GRN Pending Status for rows with Pending Qty',
          'error'
        );
        return;
      }

      const invalidQtyRows = listToValidate.filter(jde => {
        const qty = Number(jde.grnPendingQty);
        return (jde.grnPendingStatus == 1 || jde.grnPendingStatus == 2) && qty <= 0;
      });

      if (invalidQtyRows.length > 0) {
        this._apiService.showMessage(
          'Pending Qty should be greater than 0 for Partial Receipt / Credit Note',
          'error'
        );
        return;
      }

      const invalidFullyReceiptRows = listToValidate.filter(jde => {
        const qty = Number(jde.grnPendingQty);
        return jde.grnPendingStatus == 3 && qty !== 0;
      });

      if (invalidFullyReceiptRows.length > 0) {
        this._apiService.showMessage(
          'Pending Qty should be 0 for Fully Receipt',
          'error'
        );
        return;
      }


      const list = listToValidate;

      // collect all statuses
      const statuses = list.map(jde => jde.grnPendingStatus);

      // priority-based check
      let checkerStatus = "Approved for MRA";

      if (statuses.some(s => s == 1 || s == 2)) {
        checkerStatus = "Partial GRN";
      } else if (statuses.some(s => s == 3)) {
        checkerStatus = "Fully Receipt";
      }
      const editedRows = (isPVApproval
        ? this.selectedJdeList
        : this.selectedJdeList.filter(jde => jde.selected)

      ).map(jde => ({
        ASNId: jde.asnId,
        poid: jde.poid,
        orderNumber: jde.orderNumber,
        valueStream2: jde.valueStream2,
        ASNNumber: jde.asnNumber,
        grnQty: jde.grnQty,
        invoiceNumber: jde.invoiceNumber,
        invoiceDate: jde.invoiceDate,
        isApproved: true,
        isRework: false,
        grnPendingQty: jde.grnPendingQty,
        grnPendingStatus: jde.grnPendingStatus,
        SupplierId: jde.supplierId,
        checkerStatus: checkerStatus,
        itemdesc: jde.itemdesc,
        value: jde.value,
        // checkerStatus:
        //   (jde.grnPendingStatus == 1 || jde.grnPendingStatus == 2)
        //     ? "Partial GRN"
        //     : (jde.grnPendingStatus == 3)
        //       ? "Fully Receipt"
        //       : "Approved for MRA",
        itemnumber: jde.itemnumber
      }));


      const payload = {
        row: editedRows,
        remark: this.ApprovedRemark.value,
        userNameC: this.username,
        userIdC: this.userid,
        TDSType: this.selectedJdeList.tdsType,
        ASNStatus: checkerStatus
      };

      console.log('Payload to send:', payload);
      console.log('Payload:', payload);
      this.lastApprovedData = payload;
      this._utility.loader(true);
      this._apiService.asnapprove(payload).then(
        (res: any) => {
          this._utility.loader(false);
          this._apiService.showMessage(res.message, 'success');
          this.ApprovedRemark.setValue('')
          this.display = false
          this.getdata()
        },
        (err: any) => {
          this._utility.loader(false);
          this._apiService.showMessage(err.message, 'error');
        }
      );
    }
    else if (action == 'reject') {

      const isPVApproval = this.selectedJdeList[0].checkerStatus == 'AT PV Approval';
      console.log(isPVApproval, "CHECKED");

      const editedRows = (isPVApproval
        ? this.selectedJdeList
        : this.selectedJdeList.filter(jde => jde.selected)
      ).map(jde => ({
        ASNId: jde.asnId,
        poid: jde.poid,
        valueStream2: jde.valueStream2,
        ASNNumber: jde.asnNumber,
        grnQty: jde.grnQty,
        invoiceNumber: jde.invoiceNumber,
        invoiceDate: jde.invoiceDate,
        isApproved: false,
        isRework: true,
        checkerStatus: "Rework"
      }));


      const payload = {
        row: editedRows,
        remark: this.ApprovedRemark.value,
        userNameC: this.username,
        userIdC: this.userid,
        TDSType: this.selectedJdeList.tdsType
      };

      console.log('Payload to send:', payload);
      console.log('Payload:', payload);
      this.lastApprovedData = payload;
      this._utility.loader(true);
      this._apiService.asnapprove(payload).then(
        (res: any) => {
          this._utility.loader(false);
          this._apiService.showMessage(res.message, 'success');
          this.ApprovedRemark.setValue('')
          this.display = false
          this.getdata()
        },
        (err: any) => {
          this._utility.loader(false);
          this._apiService.showMessage(err.message, 'error');
        }
      );
    }
  }
  getAllTableData() {
    this._utility.loader(true);
    this._apiService.getvaluestream()
      .then((res: any) => {
        this._utility.loader(false);
        if (res.success == true) {
          this.valueStreamdropdown = res.returnValue;
          console.log(this.valueStreamdropdown);

        }
        else {
          this.valueStreamdropdown = [];
        }
      })
      .catch((error: any) => {
        this._utility.loader(false);
        this.valueStreamdropdown = [];
      })
  }
  selectedValueStreamToApply: string | null = null;
  showApplyToAllButton: boolean = false;

  // Called when a dropdown changes
  onValueStreamChange(jde: any) {
    if (jde.valueStream2 && !jde.isApproved) {
      this.selectedValueStreamToApply = jde.valueStream2;
      this.showApplyToAllButton = true;
    }
  }

  // Called when "Apply to All" is clicked
  applyValueStreamToAll() {
    if (this.selectedValueStreamToApply) {
      this.selectedJdeList.forEach(jde => {
        if (!jde.isApproved) {
          jde.valueStream2 = this.selectedValueStreamToApply;
        }
      });

      this.showApplyToAllButton = false; // Optional: hide button after applying
    }
  }
  getAllTdsData() {
    this._utility.loader(true);
    this._apiService.gettdsmster()
      .then((res: any) => {
        this._utility.loader(false);
        if (res.success == true) {
          this.tdsdropdown = res.returnValue;
        }
        else {
          this.tdsdropdown = [];
        }
      })
      .catch((error: any) => {
        this._utility.loader(false);
        this.tdsdropdown = [];
      })
  }

  isEditing = false;

  enableEdit() {
    this.isEditing = true;
  }

  disableEdit() {
    this.isEditing = false;
  }
  editasn(jde) {
    console.log(jde, "called jde ");
    this._utility.loader(true);
    const data = {
      asnnumber: jde.asnNumber
    }
    this._apiService.getgenerateddata(data).then((res: any) => {
      this._utility.loader(false);
      if (res.success) {
        const jdedatabyid = res.data.filter(asn => asn.asnNumber === jde.asnNumber);

        const mappedData = jdedatabyid.map(item => ({
          orderNumber: item.orderNumber,
          id: item.poid,
          itemNumber: item.itemnumber || item.itemNumber,
          itemDesc: item.itemdesc || item.itemDesc,
          orderDate: item.invoiceDate,
          requestedDate: item.invoiceDate,
          promisedDeliveryDate: item.invoiceDate,
          quantityOpen: item.quantityOpen || item.asnRemainingQuantity || 0,
          valueStream2: item.valueStream2,
          unitPrice: item.ship > 0 ? (item.value / item.ship) : 0,
          ship: item.ship,
          lineNumber: item.linenumber || item.lineNumber,
          orderType: item.ordertype || item.orderType,
          addressNumber: item.addressNumber || item.addressnumber,
          asnRemainingQuantity: item.asnRemainingQuantity || 0,
          businessUnit: item.businessUnit,
          supplierId: item.supplierId,
          invoiceNumber: item.invoiceNumber,
          invoiceDate: item.invoiceDate,
          asnId: item.asnId,
          invoicePath: item.invoicePath,
          deliveryChaalanPath: item.deliveryChaalanPath,
          ewayBillPath: item.ewayBillPath,
          asnrequest: item.asnrequest
        }));

        this._apiService.setSelectedData(mappedData);
        this.router.navigate(['/asn-generation'], { state: { data: mappedData } });
      } else {
        this._apiService.showMessage("Failed to fetch ASN details", "error");
      }
    }).catch((err) => {
      this._utility.loader(false);
      this._apiService.showMessage(err.message, "error");
    });
  }
  submitForm() {
    console.log(this.toolLoanForm.valid, this.toolLoanForm.value);

    if (this.toolLoanForm.valid) {
      this._utility.loader(true);
      let formData = new FormData();

      formData.append('invoice', this.toolLoanForm.controls.uploadDoc.value);
      console.log(formData);

      this._apiService.tooldocumentupload(formData).then((res: any) => {
        this._utility.loader(false);
        if (res.success == false) {
          this._apiService.showMessage(res.message, "error");
        } else {
          this._apiService.showMessage(res.message, "success");
          if (this.fileInput && this.fileInput.nativeElement) {
            this.fileInput.nativeElement.value = null;
          }
          this.displaycredit = false;
        }
      }).catch((err: any) => {
        this._utility.loader(false);
        this._apiService.showMessage(err?.message || 'Upload failed', 'error');
      });

    } else {
      this._apiService.showMessage("Please fill form details", "error");
      console.log("Form not valid");
    }
  }
  getFile(event) {
    let file = this._utility.onFileChange(event);
    this.toolLoanForm.controls['uploadDoc'].setValue(file);
  }
  resetform() {
    console.log("data");
    this.toolLoanForm.reset();
    setTimeout(() => {
      if (this.fileInput && this.fileInput.nativeElement) {
        this.fileInput.nativeElement.value = null;
        console.log("File input cleared");
      } else {
        console.warn("fileInput is still null");
      }
    });

  }
  hasPartialGRN(): boolean {
    console.log('called');

    if (!this.selectedJdeList) {
      return false;
    }

    // If it's an array → use .some()
    if (Array.isArray(this.selectedJdeList)) {
      return this.selectedJdeList.some(
        item => item?.grnPendingStatus === 1
      );
    }

    // If it's a single object
    return this.selectedJdeList.grnPendingStatus === 1;
  }

  /** Store file locally without uploading */
  onCreditNoteFileSelected(event: any) {
    const file = this._utility.onFileChange(event);
    this.pendingCreditNoteFile = file;
  }

  /** Upload the staged credit note file when Supplier clicks Submit */
  submitCreditNote() {
    if (!this.pendingCreditNoteFile) {
      this._apiService.showMessage('Please select a file first', 'error');
      return;
    }
    const formData = new FormData();
    formData.append('ASNNumber', this.selectedJdeList[0].asnNumber);
    formData.append('CreditNote', this.pendingCreditNoteFile);
    formData.append('invoiceNumber', this.selectedJdeList[0].invoiceNumber);
    formData.append('invoiceDate', this.selectedJdeList[0].invoiceDate);
    formData.append('OrderNumber', this.selectedJdeList[0].orderNumber);
    this.pendingCreditNoteFile = null; // clear staged file
    this.uploadDocument(formData);
  }

  getcredit(event) {
    let file = this._utility.onFileChange(event);
    // this.toolLoanForm.controls['uploadDoc'].setValue(file);
    console.log("caled", this.selectedJdeList[0]);

    const formData = new FormData();
    formData.append('ASNNumber', this.selectedJdeList[0].asnNumber);
    formData.append('OrderNumber', this.selectedJdeList[0].orderNumber);
    formData.append('invoiceNumber', this.selectedJdeList[0].invoiceNumber);
    formData.append('invoiceDate', this.selectedJdeList[0].invoiceDate);
    formData.append('CreditNote', file)
    this.uploadDocument(formData);
  }
  uploadDocument(formData: FormData) {

    this._apiService.uploadcreditnote(formData).subscribe({
      next: (res: any) => {
        this._utility.loader(false);
        console.log('Upload success', res.message);
        this._apiService.showMessage(res.message, "success");
        this.display = false
      },
      error: (err) => {
        this._utility.loader(false);
        console.error('Upload failed', err);
        this._apiService.showMessage(err.message, "error");
      }
    });
  }
  onGrnQtyChange(jde: any) {
    const shipQty = Number(jde.ship) || 0;
    const grnQty = Number(jde.grnQty) || 0;

    // Prevent negative or over-entry
    if (grnQty > shipQty) {
      jde.grnQty = shipQty;
    }

    // Auto calculate pending
    jde.grnPendingQty = shipQty - (Number(jde.grnQty) || 0);

    // Validate current status
    if (jde.grnPendingQty === 0 && (jde.grnPendingStatus == 1 || jde.grnPendingStatus == 2)) {
      jde.grnPendingStatus = 3; // Auto switch to Fully Receipt if qty is 0
    } else if (jde.grnPendingQty > 0 && jde.grnPendingStatus == 3) {
      jde.grnPendingStatus = ''; // Reset status if qty is > 0 but status was Fully Receipt
    }
  }

  onGrnStatusChange(jde: any) {
    console.log(jde, "Called data");

    const qty = Number(jde.grnPendingQty);
    const status = Number(jde.grnPendingStatus);

    if ((status === 1 || status === 2) && qty <= 0) {
      this._apiService.showMessage('Pending Qty should be greater than 0 for Partial Receipt / Credit Note', 'error');
      setTimeout(() => {
        jde.grnPendingStatus = '';
      }, 0);
    } else if (status === 3 && qty !== 0) {
      this._apiService.showMessage('Pending Qty should be 0 for Fully Receipt', 'error');
      setTimeout(() => {
        jde.grnPendingStatus = '';
      }, 0);
    }
  }

  calculateTotalShipAmount(): number {
    if (!this.selectedJdeList) return 0;
    return this.selectedJdeList.reduce((acc: number, jde: any) => {
      const val = parseFloat(jde.value) || 0;
      return acc + val;
    }, 0);
  }

  calculateTotalTaxAmount(): number {
    if (!this.selectedJdeList || !this.valueStreamdropdown || this.valueStreamdropdown.length === 0) return 0;

    return this.selectedJdeList.reduce((acc: number, jde: any) => {
      const shipAmount = parseFloat(jde.value) || 0;
      const vsName = jde.valueStream2;
      const vs = this.valueStreamdropdown.find((v: any) => v.valueStreamName === vsName);

      let taxRate = 0;
      if (vs) {
        taxRate = (vs.cgst || 0) + (vs.igst || 0) + (vs.sgst || 0);
      }

      const taxAmount = (shipAmount * taxRate) / 100;
      return acc + taxAmount;
    }, 0);
  }

  calculateTotalAmountWithTax(): number {
    return this.calculateTotalShipAmount() + this.calculateTotalTaxAmount();
  }
}
